import React from 'react';

const loadingOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  backdropFilter: 'blur(6px)',
  backgroundColor: 'rgba(105, 103, 123, 0.5)',
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const spinnerStyle = {
  width: '60px',
  height: '60px',
  border: '8px solid white',
  borderTop: '8px solid #1c5bbe',
  borderRadius: '50%',
  animation: 'spin 1s linear infinite',
};

const spinnerKeyframes = `
@keyframes spin {
  0% { transform: rotate(0deg) }
  100% { transform: rotate(360deg) }
}
`;

function TelaLoadind({ isVisible }) {
  if (!isVisible) return null;

  return (
    <>
      <style>{spinnerKeyframes}</style>

      <div style={loadingOverlayStyle}>
        <div style={spinnerStyle}></div>
      </div>
    </>
  );
}

export default TelaLoadind;
